import {
  Box,
  Container,
  Heading,
  Text,
  Breadcrumb,
  BreadcrumbItem,
  Stack,
  SimpleGrid,
  List,
  ListItem,
  LinkBox,
  Flex,
  Icon,
  LinkOverlay

} from "@chakra-ui/react";
import MotionInView from "../components/MotionView";
import { ChevronRightIcon, DownloadIcon } from "@chakra-ui/icons";
import { Link as ReactLink } from "react-router-dom";

const relatedDocs = [
  {
    title: "Kérelem a kihívással élő személyek nappali ellátásához",
    description:
      "",
    link: "/images/dokumentum/nappali/fogykerelem.pdf",
  },
  {
    title: "Megállapodás",
    description: "Kihívással élő személyek nappali ellátása",
    link: "/images/dokumentum/nappali/megallapodasfogy.pdf",
  },
  {
    title: "Egészségi állapotra vonatkozó igazolás",
    description:
      "A háziorvos, kezelőorvos vagy kórházi osztályos orvos tölti ki.",
    link: "/images/dokumentum/egeszsegi_igazolas.pdf",
  },
];


const FogyatekkalElok = () => {
  return (
    <Box>
      <Box
        w="full"
        h={{ base: "450px", md: "550px" }}
        bgPos="center"
        bgRepeat="no-repeat"
        bgSize="cover"
        bgImage={`linear-gradient(100deg, rgba(42, 42, 42, 0.8) 0%, rgba(42, 42, 42, 0) 90%), url(/images/virag2.jpg)`}
      >
        <Container
          maxW="container.lg"
          h={{ base: "450px", md: "550px" }}
          display="flex"
          justifyContent="center"
          alignItems="center"
          textAlign="center"
        >
          <Box
            w='100%'
            p={10}
            borderRadius='15'
            backgroundColor='black'
            opacity='0.6'
          //backgroundImage={`linear-gradient(100deg, rgba(10,10,10,0.78) 0%, rgba(10,10,10,0.10) 85%),`}
          >
            <MotionInView y={12}>
              <Heading color="white" fontWeight="900" fontSize={{ base: "3xl", md: "5xl" }}>
                KIHÍVÁSSAL ÉLŐK NAPPALI ELLÁTÁSA
              </Heading>
            </MotionInView>
          </Box>
        </Container>
      </Box>
      <Container maxW="container.xl">
        <Breadcrumb
          ms={2}
          mt={3}
          fontSize={{ base: "xs", md: "sm" }}
          spacing={{ base: "3px", md: "8px" }}
          separator={<ChevronRightIcon color="gray.400" />}
        >
          <BreadcrumbItem>
            <ReactLink to="/">Főoldal</ReactLink>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <ReactLink to="/alapszolgaltatas">Alapszolgáltatás</ReactLink>
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage>
            <Text>Kihívással élők nappali ellátása</Text>
          </BreadcrumbItem>
        </Breadcrumb>
      </Container>

      <Box py={{ base: 10, md: 14 }} bg="gray.50" textAlign='justify'>
        <Container maxW="container.xl">
          <MotionInView y={10}>
            <Box
              bg="white"
              borderWidth="1px"
              borderColor="gray.200"
              rounded="3xl"
              p={{ base: 6, md: 10 }}
              boxShadow="sm"
            >
              <Stack spacing={4}>
                <Heading fontSize={{ base: "xl", md: "2xl" }} fontWeight="900">
                  Kihívással élők nappali ellátása
                </Heading>

                <Box w="90px" h="4px" bg="yellow.400" rounded="full" />

                <Text color="gray.700" lineHeight="1.8" fontSize={{ base: "md", md: "lg" }}>
                  A Bástya Református Szociális Szolgáltató Központ fogyatékossággal élő személyek
                  nappali ellátását biztosító szolgáltatásának célja a hátrányos helyzetű célcsoportok
                  elérése, támogatása, valamint a szociális és egészségügyi ellátórendszerbe való
                  bekapcsolásuk segítése.
                </Text>
              </Stack>


               <SimpleGrid mt={5} columns={{ base: 1, md: 4 }} spacing={4} mb={{ base: 3, md: 3 }}>
                            {[
                              { k: "Férőhely", v: "25 fő" },
                              { k: "Elhelyezkedés", v: "4450, Tiszalök, Damjanich utca 24." },
                              { k: "Akadálymentesítés", v: "Rámpa" },
                              { k: "Ellátási terület", v: "Tiszalök, Tiszaeszlár, Tiszavasvári, Tiszadada, Tiszadob" },
                            ].map((x) => (
                              <Box
                                key={x.k}
                                bg="gray.50"
                                borderWidth="1px"
                                borderColor="gray.200"
                                rounded="2xl"
                                p={5}
                                textAlign="center"
                                lineHeight='normal'
                              >
                                <Text fontWeight="900">{x.k}</Text>
                                <Text mt={3}  color="gray.700">{x.v}</Text>
                              </Box>
                            ))}
                          </SimpleGrid>
            </Box>
          </MotionInView>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mt={8}>
            <MotionInView y={10}>
              <Box bg="white" rounded="2xl" borderWidth="1px" borderColor="gray.200" p={6} boxShadow="sm">
                <Heading fontSize="lg" fontWeight="900" mb={3}>
                  Kinek szól az ellátás?
                </Heading>
                <List spacing={2} color="gray.700" lineHeight="1.8">
                  <ListItem>
                    • Saját otthonukban élő, harmadik életévüket betöltött fogyatékos vagy autista személyeknek.
                  </ListItem>
                  <ListItem>
                    • Akik önkiszolgálásra részben képesek vagy nem képesek.
                  </ListItem>
                  <ListItem>
                    • Akik felügyeletre, támogatásra szorulnak napközben.
                  </ListItem>
                  <ListItem>
                    • Akik számára fontos a társas kapcsolatok fenntartása és a biztonságos közeg.
                  </ListItem>
                </List>
              </Box>
            </MotionInView>

            <MotionInView y={10} delay={0.05}>
              <Box bg="white" rounded="2xl" borderWidth="1px" borderColor="gray.200" p={6} boxShadow="sm">
                <Heading fontSize="lg" fontWeight="900" mb={3}>
                  Mit biztosítunk?
                </Heading>
                <List spacing={2} color="gray.700" lineHeight="1.8">
                  <ListItem>• Napközbeni tartózkodást és felügyeletet.</ListItem>
                  <ListItem>• Étkezést és alapvető higiénés szükségletek kielégítését.</ListItem>
                  <ListItem>• Társas kapcsolatokat, közösségi jelenlétet.</ListItem>
                  <ListItem>• Az egyéni állapothoz igazodó támogatást.</ListItem>
                </List>
              </Box>
            </MotionInView>
          </SimpleGrid>
          <MotionInView y={10}>
            <Box
              mt={8}
              bg="white"
              rounded="2xl"
              borderWidth="1px"
              borderColor="gray.200"
              p={6}
              boxShadow="sm"
            >
              <Heading fontSize="lg" fontWeight="900" mb={3}>
                Célunk
              </Heading>
              <Text color="gray.700" lineHeight="1.8">
                Az ellátottak képességeihez, igényeihez és lehetőségeihez igazodva biztosítjuk
                a gondozást, fejlesztést és foglalkozásokat. Munkánkkal elősegítjük a közösséghez
                tartozás élményét, erősítjük az önállóságot és hozzájárulunk a magasabb életminőség
                kialakításához.
              </Text>
            </Box>
          </MotionInView>
          <MotionInView y={10}>
            <Box
              mt={8}
              bg="white"
              rounded="2xl"
              borderWidth="1px"
              borderColor="gray.200"
              p={6}
              boxShadow="sm"
            >
              <Heading fontSize="lg" fontWeight="900" mb={3}>
                Közösségi és fejlesztő programok
              </Heading>

              <Text color="gray.700" lineHeight="1.8">
                Intézményünk a helyi igényekhez igazodó közösségi programokat szervez, valamint
                helyet biztosít közösségi kezdeményezéseknek és csoportfoglalkozásoknak.

              </Text>
            </Box>
          </MotionInView>
          <MotionInView y={10}>
            <Box
              mt={8}
              bg="white"
              rounded="2xl"
              borderWidth="1px"
              borderColor="gray.200"
              p={6}
              boxShadow="sm"
            >
              <Heading fontSize="lg" fontWeight="900" mb={3}>
                Amit nyújt
              </Heading>

              <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={4} mt={4}>
                {[
                  "Tanácsadás",
                  "Készségfejlesztés",
                  "Segítségnyújtás",
                  "Esetkezelés",
                  "Felügyelet (napközben, hétköznapokon)",
                  "Gondozás",
                ].map((s) => (
                  <Box
                    key={s}
                    bg="gray.50"
                    borderWidth="1px"
                    borderColor="gray.200"
                    rounded="xl"
                    p={4}
                    textAlign="center"
                    fontWeight="700"
                  >
                    {s}
                  </Box>
                ))}
              </SimpleGrid>
            </Box>
          </MotionInView>
          <MotionInView y={10}>
            <Box
              mt={8}
              bg="gray.900"
              color="white"
              rounded="2xl"
              p={{ base: 6, md: 8 }}
            >
              <Heading fontSize="xl" fontWeight="900">
                Fontos információ az igénybevételhez!
              </Heading>
              <Text mt={2}  color="whiteAlpha.900" lineHeight="1.3">
              A kérelem és az egészségi állapotra vonatkozó igazolás mellé csatolni kell a <b>fogyatékosságot megállapító</b> dokumentumot.
              </Text>
            </Box>
          </MotionInView>

          <MotionInView y={10}>
            <Box
              mt={8}
              bg="white"
              rounded="2xl"
              borderWidth="1px"
              borderColor="gray.200"
              p={6}
              boxShadow="sm"
            >
              <Heading fontSize="lg" fontWeight="900" mb={3}>
                Kapcsolódó dokumentumok
              </Heading>

              <Stack spacing={4} mt={4}>
                {relatedDocs.map((doc, index) => {
                  const isPdf = doc.link.toLowerCase().endsWith(".pdf");
                  const isDoc =
                    doc.link.toLowerCase().endsWith(".doc") ||
                    doc.link.toLowerCase().endsWith(".docx");

                  return (
                    <LinkBox
                      key={doc.link}
                      as="article"
                      role="group"
                      bg="white"
                      borderWidth="1px"
                      borderColor="gray.200"
                      rounded="xl"
                      p={{ base: 4, md: 5 }}
                      _hover={{ boxShadow: "md", transform: "translateY(-1px)" }}
                      transition="all 0.2s ease"
                    >
                      <Flex align="center" gap={4}>
                        <Box flex="1" minW={0}>
                          <Heading as="h3" fontSize={{ base: "md", md: "lg" }} fontWeight="900">
                            <LinkOverlay
                              href={doc.link}
                              target={isPdf ? "_blank" : undefined}
                              rel={isPdf ? "noreferrer" : undefined}
                              download={isDoc ? true : undefined}
                            >
                              {doc.title}
                            </LinkOverlay>
                          </Heading>
                          {doc.description ? (
                            <Text mt={2} color="gray.700" noOfLines={2}>
                              {doc.description}
                            </Text>
                          ) : null}
                        </Box>

                        <Box
                          w="48px"
                          h="48px"
                          rounded="xl"
                          borderWidth="1px"
                          borderColor="gray.200"
                          display="grid"
                          placeItems="center"
                          _groupHover={{ borderColor: "yellow.400" }}
                        >
                          <Icon as={DownloadIcon} boxSize={6} />
                        </Box>
                      </Flex>
                    </LinkBox>
                  );
                })}
              </Stack>
            </Box>
          </MotionInView>
        </Container>
      </Box>
    </Box>
  );
};

export default FogyatekkalElok;
